/* eslint-disable max-statements */

import prepareComponent from "@bluframe/grapple/prepareComponent"

import Arrow from "./Arrow"

export interface Props {
  cursor?: string | null
  direction: "next" | "prev"
  hasData?: boolean
  link: string
}

export interface ComponentProps extends Omit<Props, "link"> {
  ariaLabel: "Next" | "Previous"
  iconName: "IoChevronBack" | "IoChevronForward"
  to: string
}

export const hasLink = ({ hasData }: Props): boolean => Boolean(hasData)

export const usePrepareComponent = ({
  cursor,
  link,
  ...props
}: Props): ComponentProps => {
  let ariaLabel: ComponentProps["ariaLabel"] = "Next"
  let iconName: ComponentProps["iconName"] = "IoChevronForward"

  if (props.direction === "prev") {
    ariaLabel = "Previous"
    iconName = "IoChevronBack"
  }

  if (!cursor) {
    return {
      ...props,
      ariaLabel,
      cursor,
      iconName,
      to: link
    }
  }

  const [path, queryString] = link.split("?", 2)
  const params = new URLSearchParams(queryString ?? "")
  params.set("startAt", cursor)
  const to = `${path}?${params.toString()}`

  return {
    ...props,
    ariaLabel,
    cursor,
    iconName,
    to
  }
}

export default prepareComponent<Props, ComponentProps>(usePrepareComponent, {
  onlyRenderIf: hasLink
})(Arrow)
